module.exports = __webpack_public_path__ + "e19de074634f3b6344a3e9d779fbfee6.svg";